/* eslint-disable react/prop-types */
/**
 * SATE Block — customer portal renderer for Standard Advisory
 * Template Engine output (Layer 2). Visually distinct from the
 * deterministic explanation (Layer 1) and the Important Note (Layer 3).
 *
 * Strict visual separation rule (spec):
 *   Layer 1 — coloured 4-stage explanation cards (objective)
 *   Layer 2 — THIS — light blue "Recommended Approach" card (process)
 *   Layer 3 — subtle grey "Important Note" (advisor nuance)
 */
import { Workflow } from "lucide-react";

export default function SATEBlock({ sate, dark = false }) {
  if (!sate) return null;
  const intro = (sate.intro || "").trim();
  const outcomes = sate.outcomes || [];
  if (!intro && outcomes.length === 0) return null;
  return (
    <div
      className={`mt-2 mb-3 rounded-lg p-3 border ${
        dark
          ? "bg-slate-800/70 border-slate-700"
          : "bg-blue-50 border-blue-200"
      }`}
      data-testid={`portal-sate-${sate.template_id || "unknown"}`}
    >
      <div className="flex items-start gap-2 mb-2">
        <Workflow className={`w-4 h-4 mt-0.5 shrink-0 ${dark ? "text-blue-300" : "text-blue-600"}`} />
        <div>
          <p className={`text-[10px] uppercase tracking-wide font-bold ${dark ? "text-blue-300" : "text-blue-700"}`}>
            Recommended Approach
          </p>
          {sate.label && (
            <p className={`text-[11px] italic ${dark ? "text-slate-300" : "text-slate-600"}`}>
              {sate.label}
            </p>
          )}
        </div>
      </div>
      {intro && (
        <p className={`text-xs leading-relaxed mb-2 ${dark ? "text-slate-100" : "text-slate-800"}`}>
          {intro}
        </p>
      )}
      {outcomes.length > 0 && (
        <div>
          <p className={`text-[10px] uppercase tracking-wide font-bold mb-1 ${dark ? "text-blue-300" : "text-blue-700"}`}>
            Possible Outcomes
          </p>
          <ul className={`text-xs leading-relaxed space-y-1 list-disc list-inside ${dark ? "text-slate-100" : "text-slate-800"}`}>
            {outcomes.map((o) => (
              <li key={o.key}>{o.text}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
